// src/components/filters/ProgressSection.vue

<template>
  <div class="progress-section">
    <!-- Overall Progress -->
    <v-flex xs12 class="mb-4">
      <h4 class="gradient-text mb-2">Overall Progress</h4>
      <v-progress-linear
        rounded
        height="20"
        :value="totalProgress"
        color="#03396c"
      >
        <template v-slot:default="{ value }">
          <strong>{{ Math.ceil(value) }}% Sold</strong>
        </template>
      </v-progress-linear>
    </v-flex>

    <!-- Zone-wise Progress -->
    <v-flex xs12>
      <h4 class="gradient-text mb-2">Zone Progress</h4>
      <v-row justify="space-around">
        <v-col 
          v-for="(stat, zone) in zoneStats" 
          :key="zone"
          cols="auto"
          class="text-center"
        >
          <v-progress-circular
            :rotate="360"
            :size="60"
            :width="7"
            :value="getZoneProgress(stat)"
            color="#03396c"
          >
            {{ Math.ceil(getZoneProgress(stat)) }}%
          </v-progress-circular>
          <div class="mt-1 zone-label">Zone {{ zone }}</div>
        </v-col>
      </v-row>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProgressSection',

  computed: {
    ...mapGetters('geojson', ['filteredZoneStatistics']),    
    totalProgress() {
        const stats = this.filteredZoneStatistics;
        if (!stats) return 0;
        
        // Sum all features and sold features across zones
        const totals = Object.values(stats).reduce((acc, zone) => ({
            total: acc.total + zone.total,
            sold: acc.sold + zone.sold
        }), { total: 0, sold: 0 });
        
        return totals.total ? (totals.sold / totals.total * 100) : 0;
    },

    zoneStats() {
        return this.filteredZoneStatistics || {};
    }
  },

  methods: {
    getZoneProgress(stat) {
      return stat.total ? (stat.sold / stat.total) * 100 : 0;
    }
  }
}
</script>

<style scoped>
.zone-label {
  font-size: 0.875rem;
  color: #666;
}

.progress-section {
  padding: 16px 0;
}
</style>